import { useStaticQuery, graphql } from 'gatsby';

const useFooter = () => {
  const { strapiSite } = useStaticQuery(graphql`
    query StrapiSiteSiteFooter {
      strapiSite {
        id
        footer {
          id
          title
          content {
            data {
              childMarkdownRemark {
                html
              }
            }
          }
          menu {
            id
            title
            items {
              ...AllMenuMenuItems
            }
          }
          labels {
            id
            ...LabelFragment
          }
          image {
            id
            name
            url
            width
            height
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED,
                  width: 480,
                  quality: 100,
                  placeholder: BLURRED
                )
              }
            }
          }
          company {
            id
            name
            email
            tel
            telWithCountryCode: tel(withCountryCode: "nl")
            tel2
            tel2WithCountryCode: tel2(withCountryCode: "nl")
            fax
            street
            houseNumber
            postcode
            city
            kvk
            btw
            iban
          }
          openingHours {
            id
            ...OpeningHoursFragment
          }
          socialmedia {
            id
            ...SocialmediaFragment
          }
          rating {
            id
            score
            maximumScore
          }
        }
      }
    }
  `);

  return strapiSite.footer;
};

export default useFooter;
